// import "./markup-menu";
import $ from 'jquery'
import sliders from './components/sliders'
import 'malihu-custom-scrollbar-plugin'
import 'jquery-mousewheel'
// import { map } from './components/map';
import Tabs from "./components/tabs";
import Select from './components/select'
global.$ = global.jQuery = $
require("./components/open-close");
require("./components/accordion");
function initAccordion() {
  jQuery('ul.accordion').slideAccordion({
	  activeClass: 'active-link',
	  opener: '> a.opener',
	  slider: '> div.slide',
	  animSpeed: 300
	});
}
function initOpenClose() {
  jQuery(".faq__list li").openClose({
    hideOnClickOutside: false,
    activeClass: "active",
    opener: ".opener",
    slider: ".slide",
    animSpeed: 200,
    effect: "slide"
  });
}
document.addEventListener("DOMContentLoaded", () => {
  sliders();
  new Tabs();
  global.customSelect = new Select();
  // map();
  $('.main-text__info, .home-about__text, .partners__menu-drop').mCustomScrollbar();
  $('.header__search-btn').on('click', function () {
    $(this).toggleClass('active');
    $('.search-holder').toggleClass('active');
  });
  $('.reviews__more').each(function(index, element) {
      $(element).on('click', function(e) {
          e.preventDefault();
          $("#result-ico").html($(element).parents('.reviews__slide-box').find('.reviews__ico').html());
          $("#result-name").html($(element).parents('.reviews__slide-box').find('.reviews__name').html());
          $("#result-position").html($(element).parents('.reviews__slide-box').find('.reviews__position').html());
          $("#result-text").html($(element).parents('.reviews__slide-box').find('.reviews__text').html());
          $('.popup-review').addClass('active');
      })
  });
  $('.popup__close, .popup__overlay, .cancel').on('click', function () {
    $('.popup').removeClass('active');
  });
  if ($(window).width() < 1250) {
    $(".header__top").appendTo(".header__navigation");
    $(".programm__aside").insertAfter(".programm__table");
    $(document).on('click', ".menu-item-has-children > a", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('active-link');
      $(this).siblings('ul').toggle();
    });
    $(document).on('click', ".programm-list__title.sort", function () {
      $(this).children('.programm-list__drop').toggleClass('open');
    });
  }
  $(document).on('click', (e) => {
    if (!$(e.target).closest('.partners__menu').length) {
      $('.partners__menu').removeClass('active');
      $('.partners__menu-drop').removeClass('show');
    }
    e.stopPropagation();
  });
  if ($('.tabs li').length < 5) {
    $('.tabs').addClass('small');
  }
  $(document).on('click', ".sidebar-opener", function (e) {
    $(this).toggleClass('active');
    $(this).hasClass('active') ? $(this).html($(this).data('close')) : $(this).html($(this).data('open'));
    $('.sidebar').toggleClass('show');
  });
  $(document).on('click', ".partners__menu", function (e) {
    $(this).toggleClass('active');
    $('.partners__menu-drop').toggleClass('show');
  });
  if ($(window).width() < 767) {
    $('.tabs a').click(function () {
      var scroll_el = $(this).attr('href');
      if ($(scroll_el).length != 0) {
        $('html, body').animate({
          scrollTop: $(scroll_el).offset().top - 40
        }, 500);
      }
      return false;
    });
  }
  $(document).on('click', ".mobile-opener", function (e) {
    $(this).toggleClass('active');
    $('.header__navigation').toggleClass('active');
  });
  if ($(window).width() > 1250) {
    $(window).on('scroll', () => {
      const top = $(window).scrollTop();
     if (top > 0) {
       $('.wrapper').addClass('fixed');
     } else {
      $('.wrapper').removeClass('fixed');
     }
    });
  }
});



// WEBPACK FOOTER //
// app/scripts/index.js